import React, { Component } from 'react';
import { Modal } from 'antd';
import axios from "axios";

class ChangeAppointmentModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmLoading: false,
        };
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.deleteMaterialsCall = this.deleteMaterialsCall.bind(this);
    }
    handleOk = () => {
        this.deleteMaterialsCall();
    };
    handleCancel = () => {
        this.props.handleShowChangeAppointmentModal(false);
    };
    async deleteMaterialsCall() {
        this.setState({ confirmLoading: true });
        try {
            const res = await axios.post(
                `https://backoffice.nadu.xyz/api/material/deleteMaterialsByAppointment`, {
                materials: this.props.materialsToDelete.map((material) => material.id),
                appointment_uuid: this.props.appointment_uuid,
            }
            );
            if (res.data.ok) {
                this.props.confirmedDeletedMaterials();
            }
        } catch (error) {
            console.log(error)
        }
        this.setState({ confirmLoading: false });
        this.props.handleShowChangeAppointmentModal(false);
    }
    render() {
        const { showChangeAppointmentModal } = this.props;
        const { confirmLoading } = this.state;
        return (
            <Modal
                title={"¿Estás seguro de cambiar el tipo de cita? Se eliminarán los materiales no extra"}
                open={showChangeAppointmentModal}
                onOk={this.handleOk}
                centered={true}
                confirmLoading={confirmLoading}
                onCancel={this.handleCancel}
            >
            </Modal>
        );
    }
}

export default ChangeAppointmentModal;



// WEBPACK FOOTER //
// ./src/views/HomeVisits/ChangeAppointmentModal.jsx